// components/Desktop/Components/AboutUs.js
import React, { useState } from 'react';
import styles from './AboutUs.module.css';


const AboutUs = () => {
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true); 
  const [submissionStatus, setSubmissionStatus] = useState('idle'); // State variable and function defined 

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setIsValidEmail(validateEmail(e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); 

    if (!validateEmail(email)) {
      setSubmissionStatus('error');
      return;
    }

    try {
      setSubmissionStatus('loading');
      const appLink = "https://crossed-paths.online/app/"; // Replace this with your app's deep link scheme

      window.location.href = appLink;
      const response = await fetch('https://e-mobile-api-ituma2afya-oa.a.run.app/pre-register/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setSubmissionStatus('success');
      } else {
        setSubmissionStatus('error');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
      setSubmissionStatus('error');
    }
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <section className={styles.AboutUs}>
      <h2 className={styles.title}>Free premium plans</h2>
      <br />
      <br />
      <form onSubmit={handleSubmit} className={styles.inputContainer}> 
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={handleEmailChange}  // Correctly reference the function
          className={styles.input}
        />
        <button className={styles.button}>
          Count me in
        </button>
        <div className={styles.comingSoon}>
          Coming this<br />summer
        </div>
      </form>

      <p className={styles.text}>
        {submissionStatus === 'idle' && 'Join the list to receive a free LIFETIME membership upon launch'}
        {submissionStatus === 'loading' && 'Submitting...'}
        {submissionStatus === 'success' && 'Thank you for subscribing!'}
        {submissionStatus === 'error' && 'Something went wrong. Please try again later.'}
      </p>
      <h3 className={styles.title}>for our first 1000 users</h3>
    </section>
  );
};

export default AboutUs;
